import { render } from "./AddDeviceModal.vue?vue&type=template&id=36f42b06&scoped=true"
import script from "./AddDeviceModal.vue?vue&type=script&lang=js"
export * from "./AddDeviceModal.vue?vue&type=script&lang=js"

import "./AddDeviceModal.vue?vue&type=style&index=0&id=36f42b06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f42b06"]])

export default __exports__